const getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};
export {
  getValueAsType
};
